import React, { useEffect } from "react"
import { useParams } from "react-router-dom";

function ProductPage() {
  let { id } = useParams();

  useEffect(() => {
    if (document) {
      let frame = document
      const android = /(android)/i.test(navigator.userAgent)
      const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
      frame.location = `tabe://share/${id}`
      setTimeout(() => {
        if (android) {
          frame.location = `https://play.google.com/store/apps/details?id=com.tabe`
        } else if (iOS) {
          frame.location = `https://apps.apple.com/in/app/kiko-live/id1567183166`
        } else {
          frame.location = `https://tabe.com`
        }
      }, 5000);
    }
  }, []);

  return (
    <div>
      <p>Showing details for Product ID: {id}</p>
    </div>
  );
}

export default ProductPage;
